'use strict';

require('angular');
require("@uirouter/angularjs");
require("@uirouter/angularjs/release/stateEvents.min.js");
require("angular-animate");
require("angular-cookies");
require("angular-resource");
require("angular-sanitize");
require("angular-socket-io");
require("angular-ui-bootstrap");
require("angular-socket-io/socket.js");
require("ng-toast");

import myDirectives from '../directives';
import myComponents from '../components';

const apiVersion = require('../../package.json').apiVersion;

window._ = require('lodash');
window.moment = require('moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js');
window.md5 = require('js-md5');

angular.module('cgmemApp', [
  'ngCookies',
  'ngResource',
  'ngSanitize',
  'ngResource',
  'ngAnimate',
  'ngCookies',
  'ui.bootstrap',
  'btford.socket-io',
  'ui.router',
  'ui.router.state.events',
  'ngToast',
  myDirectives.name,
  myComponents.name
])
  .config(function ($stateProvider, $urlRouterProvider, $locationProvider, $compileProvider) {
    $urlRouterProvider
      .otherwise('/');

    $locationProvider.html5Mode(true);
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|intent):/);
  })
  .config(function ($httpProvider) {
    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {};
    }

    //disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    // extra
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

    $httpProvider.interceptors.push(function ($q, $injector) {
      return {
        'responseError': function (rejection) {
          if (rejection.status === 401) {
            var s = $injector.get('$state');
            var l = $injector.get('$log');
            l.warn("$httpInterceptor: got 401 in state", s.current.name);
            $injector.get('$rootScope').$emit('401');
          }
          if (rejection.status === 412) {
            window.location.reload(true);
          }
          return $q.reject(rejection);
        }
      };
    });
    $httpProvider.interceptors.push(function ($injector) {
      return {
        'request': function (config) {
          var User = $injector.get('User');
          var WorkingAccount = $injector.get('WorkingAccount');
          var u = User.getSync();
					var a = WorkingAccount.getSync();
          if(u && a && a.account && u.accountId != a.account._id) {
            config.headers['X-Override-AccountID'] = a.account._id;
          }
          config.headers['X-Api-Version'] = apiVersion;
          return config;
        }
      };
    });
  })
  .config(['$qProvider', function ($qProvider) {
    //$qProvider.errorOnUnhandledRejections(false);
  }])
  .config(['$logProvider', function ($logProvider) {
    $logProvider.debugEnabled(false);
  }])
  .run(function ($state, $rootScope, $log, Socket) {
    $rootScope.$on('$stateChangeStart',
      function (event, toState, toParams, fromState, fromParams) {
        //$log.debug("Changing states from '"+fromState.name+"' to '"+toState.name+"'");
      });
    $rootScope.$on('$stateChangeSuccess',
      function (event, toState, toParams, fromState, fromParams) {
        //$log.info("Sucess Changing states from '"+fromState.name+"' to '"+toState.name+"'");
      });

    $rootScope.$on('$stateChangeError',
      function (event, toState, toParams, fromState, fromParams, error) {
        //$log.debug("Error Changing states from '"+fromState.name+"' to '"+toState.name+"':", error);
      });
    $rootScope.$on('$stateNotFound',
      function (event, toState, toParams, fromState, fromParams, error) {
        //$log.debug("State not found changing states from '"+fromState.name+"' to '"+toState.name+"':", error);
      });

  })
  .config(function (ngToastProvider) {
    ngToastProvider.configure({
      className: 'success',
      animation: 'fade',
      horizontalPosition: 'right',
      timeout: 3000
    })
  })

angular.module('cgmemApp')
  // allow DI for use in controllers, unit tests
  .constant('_', window._)
  // use in views, ng-repeat="x in _.range(3)"
  .run(function ($rootScope) {
    $rootScope._ = window._;
  });


require("./about/about.js");
require("./accountEdit/accountEdit.controller.js");
require("./accountEdit/accountEdit.js");
require("./accountShop/accountShop.controller.js");
require("./accountShop/accountShop.js");
require("./accountView/accountView.controller.js");
require("./accountView/accountView.js");
require("./activate/activate.controller.js");
require("./activate/activate.js");
require("./admin/admin.controller.js");
require("./admin/admin.js");
require("./adminCheckins/adminCheckins.controller.js");
require("./adminCheckins/adminCheckins.js");
require("./adminListOfAccounts/adminListOfAccounts.controller.js");
require("./adminListOfAccounts/adminListOfAccounts.js");
require("./adminSummary/adminSummary.controller.js");
require("./adminSummary/adminSummary.js");
require("./adminSysLog/adminSysLog.controller.js");
require("./adminSysLog/adminSysLog.js");
require("./adminTransactions/adminTransactions.controller.js");
require("./adminTransactions/adminTransactions.js");
require("./authenticatedWrap/authenticatedWrap.controller.js");
require("./authenticatedWrap/authenticatedWrap.js");
require("./courtReservation/courtReservation.controller.js");
require("./courtReservation/courtReservation.js");
require("./editMembers/editMembers.controller.js");
require("./editMembers/editMembers.js");
require("./frontdesk/frontdesk-ccpay.js");
require("./frontdesk/frontdesk-checkin.js");
require("./frontdesk/frontdesk-notices.js");
//require("./frontdesk/frontdesk.controller.js");
require("./frontdesk/frontdesk-autocheckin.js");
require("./frontdesk/frontdesk.js");
require("./help/help.controller.js");
require("./help/help.js");
require("./login/login.controller.js");
require("./login/login.js");
require("./passwordResetRequest/passwordResetRequest.controller.js");
require("./passwordResetRequest/passwordResetRequest.js");
require("./profile/profile.controller.js");
require("./profile/profile.js");
require("./reports/reports.js");
require("./services/account/account.service.js");
require("./services/activate/activate.service.js");
require("./services/appconfig/appconfig.service.js");
require("./services/braintree/braintree.service.js");
require("./services/checkin/checkin.service.js");
require("./services/logger/logger.service.js");
require("./services/member/member.service.js");
require("./services/notices/notice.service.js");
require("./services/pass/pass.service.js");
require("./services/socket/socket.service.js");
require("./services/sysvars/sysvars.service.js");
require("./services/transaction/transaction.service.js");
require("./services/user/user.service.js");
require("./mailprefs/mailprefs.js");
require("./mailprefs/mailprefs.controller.js");
require("./signup/signup.js");


//import 'font-awesome/css/font-awesome.min.css';   //loaded from CDN for now
require("bootstrap/dist/css/bootstrap.min.css");
require("ng-toast/dist/ngToast.min.css");
require("ng-toast/dist/ngToast-animations.min.css");

require("./app.css");
require("./about/about.css");
require("./accountEdit/accountEdit.css");
require("./accountShop/accountShop.css");
require("./activate/activate.css");
require("./admin/admin.css");
require("./adminTransactions/adminTransactions.css");
require("./authenticatedWrap/authenticatedWrap.css");
require("./courtReservation/courtReservation.css");
require("./help/help.css");
require("./passwordResetRequest/passwordResetRequest.css");
require("./profile/profile.css");



